/* tslint:disable */
/* eslint-disable */
/**
 * Bioplan API
 * Backend API for Bioplan, an aquaculture production planning tool.
 *
 * Contact: support@optimeeringaqua.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type {Configuration} from '../configuration';
import type {AxiosPromise, AxiosInstance, RawAxiosRequestConfig} from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
} from '../common';
// @ts-ignore
import {BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap} from '../base';
// @ts-ignore
import type {PublishPlan} from '../bioplanModels';
/**
 * PublishApi - axios parameter creator
 * @export
 */
export const PublishApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Get a preview of the payload that can be published to the Bioplan external API.
     * @param {string} planId
     * @param {string} name
     * @param {PublishPreviewGetTypeEnum} type
     * @param {string} [comment]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    publishPreviewGet: async (
      planId: string,
      name: string,
      type: PublishPreviewGetTypeEnum,
      comment?: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'planId' is not null or undefined
      assertParamExists('publishPreviewGet', 'planId', planId);
      // verify required parameter 'name' is not null or undefined
      assertParamExists('publishPreviewGet', 'name', name);
      // verify required parameter 'type' is not null or undefined
      assertParamExists('publishPreviewGet', 'type', type);
      const localVarPath = `/publish/preview`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'GET', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (planId !== undefined) {
        localVarQueryParameter['planId'] = planId;
      }

      if (name !== undefined) {
        localVarQueryParameter['name'] = name;
      }

      if (type !== undefined) {
        localVarQueryParameter['type'] = type;
      }

      if (comment !== undefined) {
        localVarQueryParameter['comment'] = comment;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Publish plan to Bioplan External API.
     * @param {string} planId
     * @param {string} name
     * @param {PublishPutTypeEnum} type
     * @param {string} [comment]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    publishPut: async (
      planId: string,
      name: string,
      type: PublishPutTypeEnum,
      comment?: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'planId' is not null or undefined
      assertParamExists('publishPut', 'planId', planId);
      // verify required parameter 'name' is not null or undefined
      assertParamExists('publishPut', 'name', name);
      // verify required parameter 'type' is not null or undefined
      assertParamExists('publishPut', 'type', type);
      const localVarPath = `/publish`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'PUT', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (planId !== undefined) {
        localVarQueryParameter['planId'] = planId;
      }

      if (name !== undefined) {
        localVarQueryParameter['name'] = name;
      }

      if (type !== undefined) {
        localVarQueryParameter['type'] = type;
      }

      if (comment !== undefined) {
        localVarQueryParameter['comment'] = comment;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * PublishApi - functional programming interface
 * @export
 */
export const PublishApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = PublishApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @summary Get a preview of the payload that can be published to the Bioplan external API.
     * @param {string} planId
     * @param {string} name
     * @param {PublishPreviewGetTypeEnum} type
     * @param {string} [comment]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async publishPreviewGet(
      planId: string,
      name: string,
      type: PublishPreviewGetTypeEnum,
      comment?: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PublishPlan>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.publishPreviewGet(planId, name, type, comment, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['PublishApi.publishPreviewGet']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Publish plan to Bioplan External API.
     * @param {string} planId
     * @param {string} name
     * @param {PublishPutTypeEnum} type
     * @param {string} [comment]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async publishPut(
      planId: string,
      name: string,
      type: PublishPutTypeEnum,
      comment?: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.publishPut(planId, name, type, comment, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['PublishApi.publishPut']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * PublishApi - factory interface
 * @export
 */
export const PublishApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
  const localVarFp = PublishApiFp(configuration);
  return {
    /**
     *
     * @summary Get a preview of the payload that can be published to the Bioplan external API.
     * @param {PublishApiPublishPreviewGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    publishPreviewGet(
      requestParameters: PublishApiPublishPreviewGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<PublishPlan> {
      return localVarFp
        .publishPreviewGet(
          requestParameters.planId,
          requestParameters.name,
          requestParameters.type,
          requestParameters.comment,
          options,
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Publish plan to Bioplan External API.
     * @param {PublishApiPublishPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    publishPut(requestParameters: PublishApiPublishPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
      return localVarFp
        .publishPut(
          requestParameters.planId,
          requestParameters.name,
          requestParameters.type,
          requestParameters.comment,
          options,
        )
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * Request parameters for publishPreviewGet operation in PublishApi.
 * @export
 * @interface PublishApiPublishPreviewGetRequest
 */
export interface PublishApiPublishPreviewGetRequest {
  /**
   *
   * @type {string}
   * @memberof PublishApiPublishPreviewGet
   */
  readonly planId: string;

  /**
   *
   * @type {string}
   * @memberof PublishApiPublishPreviewGet
   */
  readonly name: string;

  /**
   *
   * @type {'harvest' | 'production'}
   * @memberof PublishApiPublishPreviewGet
   */
  readonly type: PublishPreviewGetTypeEnum;

  /**
   *
   * @type {string}
   * @memberof PublishApiPublishPreviewGet
   */
  readonly comment?: string;
}

/**
 * Request parameters for publishPut operation in PublishApi.
 * @export
 * @interface PublishApiPublishPutRequest
 */
export interface PublishApiPublishPutRequest {
  /**
   *
   * @type {string}
   * @memberof PublishApiPublishPut
   */
  readonly planId: string;

  /**
   *
   * @type {string}
   * @memberof PublishApiPublishPut
   */
  readonly name: string;

  /**
   *
   * @type {'harvest' | 'production'}
   * @memberof PublishApiPublishPut
   */
  readonly type: PublishPutTypeEnum;

  /**
   *
   * @type {string}
   * @memberof PublishApiPublishPut
   */
  readonly comment?: string;
}

/**
 * PublishApi - object-oriented interface
 * @export
 * @class PublishApi
 * @extends {BaseAPI}
 */
export class PublishApi extends BaseAPI {
  /**
   *
   * @summary Get a preview of the payload that can be published to the Bioplan external API.
   * @param {PublishApiPublishPreviewGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PublishApi
   */
  public publishPreviewGet(requestParameters: PublishApiPublishPreviewGetRequest, options?: RawAxiosRequestConfig) {
    return PublishApiFp(this.configuration)
      .publishPreviewGet(
        requestParameters.planId,
        requestParameters.name,
        requestParameters.type,
        requestParameters.comment,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Publish plan to Bioplan External API.
   * @param {PublishApiPublishPutRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PublishApi
   */
  public publishPut(requestParameters: PublishApiPublishPutRequest, options?: RawAxiosRequestConfig) {
    return PublishApiFp(this.configuration)
      .publishPut(
        requestParameters.planId,
        requestParameters.name,
        requestParameters.type,
        requestParameters.comment,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * @export
 */
export const PublishPreviewGetTypeEnum = {
  Harvest: 'harvest',
  Production: 'production',
} as const;
export type PublishPreviewGetTypeEnum = (typeof PublishPreviewGetTypeEnum)[keyof typeof PublishPreviewGetTypeEnum];
/**
 * @export
 */
export const PublishPutTypeEnum = {
  Harvest: 'harvest',
  Production: 'production',
} as const;
export type PublishPutTypeEnum = (typeof PublishPutTypeEnum)[keyof typeof PublishPutTypeEnum];
